import { PersistedStorageState } from '../interfaces/state';


export const PERSISTED_STORAGE_INITIAL_STATE: PersistedStorageState = {
  theme: 'light',
  darkTone: 'night',
  lightTone: null,
  selectedCompanyId: null,
};
